import { DataConstant } from "../constants/data.constant";
import { encryptData, getItem, setItem } from "./EncrptDecrypt";

export const getJwtToken=()=>{
    const jwt=getItem(DataConstant.sessionStorage.JWT_TOKEN);
    return jwt?.token;
}

export const setJwtToken=(token)=>{
    return setItem(DataConstant.sessionStorage.JWT_TOKEN,JSON.stringify({token}));
}

export const getUserResponse=()=>{
    return getItem(DataConstant.sessionStorage.USER_RESPONSE);
}

export const setUserResponse=(data)=>{
    setItem(DataConstant.sessionStorage.USER_RESPONSE,JSON.stringify(data));
}

export const getLoginResponse=()=>{
    return getItem(DataConstant.sessionStorage.LOGIN_RESPONSE);
}

export const setLoginResponse=(data)=>{
    setItem(DataConstant.sessionStorage.LOGIN_RESPONSE,JSON.stringify(data));
}

export const getPayload=()=>{
    const payload = getItem(DataConstant.sessionStorage.PAYLOAD);
    return payload
}

export const setPayload=(data,key)=>{

    let payload=getPayload();
    if(payload==null) payload={};
    payload[key]=data;
    setItem(DataConstant.sessionStorage.PAYLOAD,JSON.stringify(payload));
}

export const getCurrentPage=()=>{
    return getItem(DataConstant.sessionStorage.PAGE_TRACKER);
}

export const setCurrentPage=(name,path)=>{
    let navigation=getItem(DataConstant.sessionStorage.PAGE_TRACKER);
    if(navigation==undefined){
        navigation={
            NAME:name,
            PATH:path,
            PREVIOUS_PATH:null
        }
    }
    else{
        navigation={
            NAME:name,
            PREVIOUS_PATH:navigation.PATH,
            PATH:path
        }
    }

    setItem(DataConstant.sessionStorage.PAGE_TRACKER,JSON.stringify(navigation));

    // localStorage.setItem(DataConstant.sessionStorage.PAGE_TRACKER,JSON.stringify(navigation));
}

export const logoutUser=()=>{
    localStorage.clear();
}

export const isTokenExpired=(token) =>{
    const payloadBase64 = token.split('.')[1];
    const decodedPayload = JSON.parse(atob(payloadBase64));

    const currentTime = Math.floor(Date.now() / 1000);

    return decodedPayload.exp < currentTime;
}

export const isCurrentAndPreviousPageSame=()=>{
    const page_tracker=getItem(DataConstant.sessionStorage.PAGE_TRACKER);
    return page_tracker!=undefined && page_tracker.PATH==page_tracker.PREVIOUS_PATH?true:false;
}


